// A menu opens with its first item over the trigger
const menuPosition = {
  anchorOrigin: { vertical: "center", horizontal: "left" },
  transformOrigin: { vertical: 24.5, horizontal: "left" }
};

const props = {
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
    }
  },
  MuiButton: {
    defaultProps: {
      color: "inherit"
    }
  },
  MuiCardHeader: {
    defaultProps: {
      slotProps: {
        title: { variant: "h6" }
      }
    }
  },
  MuiTextField: {
    defaultProps: {
      variant: "standard"
    }
  },
  MuiLink: {
    defaultProps: {
      underline: "hover"
    }
  },
  MuiIconButton: {
    defaultProps: {
      size: "large"
    }
  },
  MuiMenu: {
    defaultProps: menuPosition
  },
  MuiDesktopDatePicker: {
    defaultProps: {
      dayOfWeekFormatter: date => date.toLocaleDateString("en-US", { weekday: "short" }).slice(0, 2),
      slotProps: {
        actionBar: { actions: [] },
        // The field is not highlighted while its calendar is open
        field: { focused: undefined },
        // The calendar is centered under the input, left of the calendar button
        popper: { placement: "bottom", modifiers: [{ name: "offset", options: { offset: [-28, 0] } }] }
      }
    }
  },
  MuiTablePagination: {
    defaultProps: {
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
    }
  },
  MuiSwitch: {
    defaultProps: {
      color: "secondary"
    }
  },
  MuiSelect: {
    defaultProps: {
      variant: "standard",
      MenuProps: menuPosition
    }
  },
  MuiFormControl: {
    defaultProps: {
      variant: "standard"
    }
  }
};

export default props;
